import { render, staticRenderFns } from "./AddNewUserForm.vue?vue&type=template&id=71b71d8b&scoped=true&"
import script from "./AddNewUserForm.vue?vue&type=script&lang=js&"
export * from "./AddNewUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b71d8b",
  null
  
)

export default component.exports